import React from "react";

const isAnswered = (status) => status === "correct" || status === "incorrect";

function ReadingSentence({ isPlaying, isSelected, sentence, sentenceKey, onSelect }) {
  const className = ["story-sentence", isSelected && "selected", isPlaying && "playing"].filter(Boolean).join(" ");
  return (
    <>
      <span className={className} data-testid={`story-sentence-${sentenceKey}`} onClick={(event) => onSelect(sentence, sentenceKey, event.detail)}>{sentence.text}</span>{" "}
    </>
  );
}

function ClozeSentence({ isActive, isSelected, item, status, onBlankClick, onSelect }) {
  const isBlankUnanswered = !!item.cloze && !isAnswered(status);
  const className = ["story-sentence", isSelected && "selected", isBlankUnanswered && "unanswered"].filter(Boolean).join(" ");
  const openSentence = (event) => !isBlankUnanswered && onSelect(item.sentence, item.key, event.detail);

  if (!item.cloze) {
    return (
      <>
        <span className={className} data-testid={`story-sentence-${item.key}`} onClick={openSentence}>{item.sentence.text}</span>{" "}
      </>
    );
  }

  const blankClassName = ["cloze-blank", isActive && "active", isAnswered(status) && status].filter(Boolean).join(" ");
  return (
    <>
      <span className={className} data-testid={`story-sentence-${item.key}`} onClick={openSentence}>
        {item.cloze.before}
        <button
          aria-label={isBlankUnanswered ? "Fill in the blank" : item.cloze.answer}
          className={blankClassName}
          data-testid={`cloze-story-blank-${item.key}`}
          type="button"
          onClick={(event) => {
            event.stopPropagation();
            isBlankUnanswered ? onBlankClick(item.key) : openSentence(event);
          }}
        >
          {isAnswered(status) ? item.cloze.answer : ""}
        </button>
        {item.cloze.after}
      </span>{" "}
    </>
  );
}

export function ReadingStoryText({ paragraphs, playingSentenceId, selectedKey, onSelect }) {
  return (
    <div className="story-text">
      {paragraphs.map((paragraph, paragraphIndex) => (
        <p key={paragraphIndex}>
          {paragraph.sentences.map((sentence, sentenceIndex) => {
            const key = `${paragraphIndex}-${sentenceIndex}`;
            return (
              <ReadingSentence
                isPlaying={playingSentenceId === sentence.id}
                isSelected={selectedKey === key}
                key={key}
                sentence={sentence}
                sentenceKey={key}
                onSelect={onSelect}
              />
            );
          })}
        </p>
      ))}
    </div>
  );
}

export function ClozeStoryText({ activeKey, clozeParagraphs, selectedKey, statuses, onBlankClick, onSelect }) {
  return (
    <div className="story-text cloze-story-text">
      {clozeParagraphs.map((paragraph, paragraphIndex) => (
        <p key={paragraphIndex}>
          {paragraph.map((item) => (
            <ClozeSentence
              isActive={activeKey === item.key}
              isSelected={selectedKey === item.key}
              item={item}
              key={item.key}
              status={statuses[item.key]}
              onBlankClick={onBlankClick}
              onSelect={onSelect}
            />
          ))}
        </p>
      ))}
    </div>
  );
}
